<template>
  <div id="contenedor-main-expediente">
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="table-heading, table-tbody">
    </v-skeleton-loader>
    <div v-else>
      <!-- ToolBar -->
      <tool-bar
        v-if="getExistenDocumentos"
        :estaCargando="mostrarDescargando"
        :soloLectura="soloLectura"
        class="my-3"
        v-on:crearExpediente="mostrarCrearExpediente = true"
        v-on:agregarDocumentoExpediente="agregarDocumentoExpediente"
        @expotar="mixExportarDocumentosPdf(getContrato.numero)">
      </tool-bar>
      <!-- Si no hay catalogo mostrar boton -->
    <template v-if="!soloLectura">
      <v-card
      flat
      v-if="getDocumentosExpedienteContrato.length <= 0 && !getExistenDocumentos"
    >
      <v-card-text>
        <v-row class="my-4" justify="center">
            <custom-button
              v-if="mixValidaScopesActions(1)"
              label="Crear Expediente"
              iconText="mdi-plus"
              tipo="agregar"
              @click="mostrarCrearExpediente=true">
            </custom-button>
        </v-row>
      </v-card-text>
    </v-card>
    </template>
    <!-- Cuando no hay expediente registrado y es solo lectura -->
    <template v-if="!getExistenDocumentos && soloLectura">
      <v-card flat>
        <v-card-text>
          <v-row justify="center" align="center">
            <v-alert class="mt-4" type="info"> No hay expediente registrado. </v-alert>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
    <v-card>
      <estadisticas
      v-if="getExistenDocumentos"
      :datosEstadisticos="getEstadisticas"
      v-on:buscar="buscar">
      </estadisticas>
      <listado
      v-if="getExistenDocumentos"
      :listadoDocumentosExpedienteContrato="getDocumentosExpedienteContrato"
      :soloLectura="soloLectura"
      />
      </v-card>
      <v-dialog
      v-if="mostrarAgregarDocumentoExpediente"
      v-model="mostrarAgregarDocumentoExpediente"
      width="1200">
        <agregar-documento-expediente
          :idReferencia="idReferencia"
          :moduloExpedienteOrigen="moduloExpedienteOrigen"
          :catalogoExpediente="getCatalogoExpediente"
          :expedientePorContrato="getDocumentosExpedienteContrato"
          :contrato="getContrato"
          v-on:cerrar="cerrarVentana"
        />
      </v-dialog>
      <v-dialog
      v-if="mostrarCrearExpediente"
      v-model="mostrarCrearExpediente"
      scrollable
      width="1500">
      <v-card>
        <v-card-title class="secondary--text">
          Crear Expediente
          <v-spacer></v-spacer>
          <v-btn icon @click="$refs.crearExpediente.cerrar()">
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>
        <div>
            <custom-text-field
              cols=6
              v-model="buscarDocumento"
              append-icon="mdi-magnify"
              label="Buscar documento..."
              single-line
              hide-details>
            </custom-text-field>
          </div>
        <v-card-text>
          <crear-expediente
          ref="crearExpediente"
          :idReferencia="idReferencia"
          :moduloExpedienteOrigen="moduloExpedienteOrigen"
          :catalogoExpediente="getCatalogoExpediente"
          :tipoDeContrato="getTipoContrato"
          :buscarDocumento="buscarDocumento"
          v-on:cerrar="cerrarVentana"
          v-on:formularioValido="setCrearExpedienteFormularioValido"
          v-on:enviandoFormulario="setCrearExpedienteEnviandoFormulario"
        />
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="$refs.crearExpediente.cerrar()"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="$refs.crearExpediente.crearExpediente()"
            :disabled="!crearExpedienteFormularioValido || crearExpedienteEnviandoFormulario"
            :loading="crearExpedienteEnviandoFormulario"
            tipo="formAceptar"
            label="Crear Expediente">
          </custom-button>
        </v-card-actions>
      </v-card>
      </v-dialog>
      <v-dialog
        v-if="esteDocumentoExpediente"
        v-model="mostrarEditarDocumentoExpediente"
        width="1200"
      >
        <editar-documento-expediente
          :expedienteDocumentoEditar="esteDocumentoExpediente"
          v-on:cerrar="cerrarVentana"
        />
      </v-dialog>
      <v-dialog
        v-if="esteDocumentoExpediente"
        v-model="mostrarEliminarDocumetoExpediente"
        width="500"
      >
        <eliminar-documento-expediente
          :documentoExpedienteEliminar="esteDocumentoExpediente"
          :idReferenciaExpedienteDocumento="idReferencia"
          v-on:cerrar="cerrarVentana"
        />
      </v-dialog>
      <v-dialog
        v-if="esteDocumentoExpediente"
        v-model="mostrarVerDocumentoExpediente"
        width="1200"
        scrollable>
        <v-card>
          <v-card-title class="secondary--text">
            Vista Documento de Expediente
            <v-spacer></v-spacer>
            <v-btn icon @click="cerrarVentana">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <ver-documento-pdf
            :documentoPdfVer="esteDocumentoExpediente"
            :moduloOrigen="moduloExpedienteOrigen"
            v-on:cerrar="cerrarVentana"
          />
          </v-card-text>
          <v-divider class="bkground" />
          <v-card-actions>
            <v-spacer></v-spacer>
            <custom-button
              @click="cerrarVentana"
              tipo="formCancelar"
              label="Cerrar"
              class="mr-3">
            </custom-button>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-if="progresoDescarga"
        v-model="mostrarDescargando"
        width="200"
        persistent>
        <v-card>
          <v-card-title class="secondary--text">
            <v-row justify="center">
              Descargando
            </v-row>
          </v-card-title>
          <v-row class="pa-4" justify="center" align="center">
            <v-progress-circular
              :size="100"
              :width="15"
              :value="progresoDescarga"
              color="blue darken-1"
              dark
              >
              <h3>{{ progresoDescarga }}%</h3>
            </v-progress-circular>
          </v-row>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import EXPEDIENTE_POR_CONTRATO from '@/graphql/querys/administracion/expediente/expedientePorContrato.gql';
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import CATALOGO_EXPEDIENTE from '@/graphql/querys/administracion/catalogos/expedientes/catalogoExpediente.gql';
import EditarDocumentoExpediente from '@/components/administracion/expedientes/documentos/Editar.vue';
import AgregarDocumentoExpediente from '@/components/administracion/expedientes/documentos/Agregar.vue';
import EliminarDocumentoExpediente from '@/components/administracion/expedientes/documentos/Eliminar.vue';
import verDocumentoPdf from '@/components/VistaDocumentoPdf.vue';
import CrearExpediente from '@/components/administracion/expedientes/CrearExpediente.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';
import CustomButton from '@/components/buttons/Button.vue';
import mixDescargarArchivo from '@/helpers/mixDescargarArchivo';
import Estadisticas from './Estadisticas.vue';
import CustomTextField from '@/components/inputs/TextField.vue';

export default {
  name: 'ExpedienteMain',
  mixins: [mixDescargarArchivo],
  props: {
    idReferencia: {
      type: String,
      required: true,
    },
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
    tipoLista: {
      type: Boolean,
      required: false,
      default: true,
    },
    moduloExpedienteOrigen: {
      type: String,
      required: true,
    },
  },
  components: {
    ToolBar,
    Listado,
    Estadisticas,
    AgregarDocumentoExpediente,
    EditarDocumentoExpediente,
    EliminarDocumentoExpediente,
    verDocumentoPdf,
    CrearExpediente,
    CustomButton,
    CustomTextField,
  },
  data() {
    return {
      mostrarCrearExpediente: false,
      mostrarAgregarDocumentoExpediente: false,
      mostrarEditarDocumentoExpediente: false,
      mostrarEliminarDocumetoExpediente: false,
      mostrarVerDocumentoExpediente: false,
      mostrarDescargando: false,
      progresoDescarga: null,
      esteDocumentoExpediente: null,
      buscarTexto: '',
      buscarDocumento: '',
      crearExpedienteFormularioValido: false,
      crearExpedienteEnviandoFormulario: false,
    };
  },
  apollo: {
    expedientePorContrato: {
      query: EXPEDIENTE_POR_CONTRATO,
      variables() {
        return {
          idContrato: this.idReferencia,
        };
      },
    },
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.idReferencia,
        };
      },
    },
    catalogoExpediente: {
      query: CATALOGO_EXPEDIENTE,
    },
  },
  methods: {
    setCrearExpedienteEnviandoFormulario(valor) {
      this.crearExpedienteEnviandoFormulario = valor;
    },
    setCrearExpedienteFormularioValido(valor) {
      this.crearExpedienteFormularioValido = valor;
    },
    cerrarVentana() {
      this.mostrarAgregarDocumentoExpediente = false;
      this.mostrarEditarDocumentoExpediente = false;
      this.mostrarEliminarDocumetoExpediente = false;
      this.mostrarVerDocumentoExpediente = false;
      this.mostrarCrearExpediente = false;
      this.mostrarDescargando = false;
      this.esteDocumentoExpediente = null;
      this.progresoDescarga = null;
    },
    agregarDocumentoExpediente() {
      this.mostrarAgregarDocumentoExpediente = true;
    },
    buscar(buscarTexto) {
      this.buscarTexto = buscarTexto;
    },
  },
  computed: {
    getExistenDocumentos() {
      if (this.expedientePorContrato.length === 0) return false;
      return true;
    },
    getContrato() {
      if (!this.contrato) return {};
      return this.contrato;
    },
    getTipoContrato() {
      if (!this.contrato) return '';
      const obra = this.contrato.obras[0];
      return obra.obra.tipo.descripcion;
    },
    getCatalogoExpediente() {
      if (!this.catalogoExpediente) return [];
      return this.catalogoExpediente
        .slice()
        .sort((a, b) => (a.orden - b.orden));
    },
    getDocumentosExpedienteContrato() {
      if (!this.expedientePorContrato) return [];
      return this.expedientePorContrato
        .filter((documentoExpediente) => {
          if (!this.buscarTexto) return documentoExpediente;
          const expt = new RegExp(this.buscarTexto, 'gi');
          const descripcion = this.$normalizacionTexto(documentoExpediente.documento.descripcion);
          const referencia = this.$normalizacionTexto(documentoExpediente.referencia);

          return (
            expt.test(descripcion)
            || expt.test(referencia)
            || expt.test(documentoExpediente.documento.descripcion)
            || expt.test(documentoExpediente.referencia)
          );
        })
        .sort((a, b) => a.referencia.localeCompare(b.referencia))
        .sort((a, b) => a.documento.orden - b.documento.orden);
    },
    mostrarToolBar() {
      if (this.soloLectura || this.tipoLista) return false;
      return true;
    },
    getEstadisticas() {
      if (!this.expedientePorContrato) return {};
      const documentosTotales = this.getDocumentosTotales;
      const documentosAplican = this.getDocumentosAplican;
      const documentosFaltantes = this.getDocumentosFaltantes;
      const documentosIntegrados = this.getDocumentosIntegrados;
      return {
        documentosTotales,
        documentosAplican,
        documentosFaltantes,
        documentosIntegrados,
      };
    },
    getDocumentosTotales() {
      if (!this.expedientePorContrato) return 0;
      const documentosTotales = this.expedientePorContrato.length;
      return documentosTotales;
    },
    getDocumentosAplican() {
      if (!this.expedientePorContrato) return 0;
      let documentosAplican = 0;
      this.expedientePorContrato.forEach((documento) => {
        if (documento.aplica) documentosAplican += 1;
      });
      return documentosAplican;
    },
    getDocumentosFaltantes() {
      if (!this.expedientePorContrato) return 0;
      let documentosFaltantes = 0;
      this.expedientePorContrato.forEach((documento) => {
        if (!documento.existe && documento.aplica) documentosFaltantes += 1;
      });
      return documentosFaltantes;
    },
    getDocumentosIntegrados() {
      if (!this.expedientePorContrato) return 0;
      let documentosIntegrados = 0;
      this.expedientePorContrato.forEach((documento) => {
        if (documento.publicKey) documentosIntegrados += 1;
      });
      return documentosIntegrados;
    },
    getSoloPublicKeys() {
      if (!this.expedientePorContrato) return [];
      return this.expedientePorContrato
        .filter(({ publicKey }) => publicKey !== null)
        .map(({ publicKey }) => publicKey);
    },
  },
  mounted() {
    eventBus.$on('agregar-documento-expediente', (documentoExpediente) => {
      this.esteDocumentoExpediente = documentoExpediente;
      this.mostrarAgregarDocumentoExpediente = true;
    });
    eventBus.$on('editar-documento-expediente', (documentoExpediente) => {
      this.esteDocumentoExpediente = documentoExpediente;
      this.mostrarEditarDocumentoExpediente = true;
    });
    eventBus.$on('borrar-documento-expediente', (documentoExpediente) => {
      this.esteDocumentoExpediente = documentoExpediente;
      this.mostrarEliminarDocumetoExpediente = true;
    });
    eventBus.$on('ver-documento-expediente', (documentoExpediente) => {
      this.esteDocumentoExpediente = documentoExpediente;
      this.mostrarVerDocumentoExpediente = true;
    });
  },
};
</script>

<style lang="scss">
</style>
